import { getCookie, setCookie } from 'chemistry'
import { dispatch } from '../../../../common/pageBus'
import { SHOW_PRODUCT_DETAILS_EVENT_TYPE } from '../../../pageBusEvents'
import { useEffect } from 'react'

export const useProductAnalytic = productDetails => {
  useEffect(() => {
    const listerType = getCookie('analyticListType')
    dispatch({
      type: SHOW_PRODUCT_DETAILS_EVENT_TYPE,
      productDetails: {
        ...productDetails,
        listerType
      }
    })

    if (listerType) {
      // we want to remove this cookie as far as user landed on page. Can be improved in future
      setCookie('analyticListType', '', {
        path: '/',
        expires: new Date(0) // Thu, 01 Jan 1970 00:00:01 GMT
      })
    }
  }, [productDetails])
}
